@import "~@govbr-ds/core/src/components/tab/tab";

:host {
  display: block;
  height: 100%;
  min-height: 0;
  overflow: hidden;
  --br-tab-height: auto;
}

.br-tab {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: var(--br-tab-height);
  min-height: 0;
  width: 100%;
  overflow: hidden;
  padding: var(--tab-container-padding, 16px);

  &.scroll-disabled {
    height: auto;
    min-height: auto;
    overflow: visible;
  }
}

.tab-nav {
  flex: 0 0 auto;

  &[data-counter="true"] {
    min-height: 102px;
    overflow: hidden;

    ul {
      max-height: 65px;
    }
  }

  .tab-item {
    button {
      .icon:not(:only-child) {
        margin-right: var(--spacing-scale-base);
      }
    }
  }

  .tab-item.disabled {
    button[disabled] {
      cursor: not-allowed;
      opacity: var(--opacity-md, 0.45);
      pointer-events: none;
    }
  }
}

.tab-content {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;

  .scroll-disabled & {
    overflow: hidden;
  }
}

.results {
  display: flex;
  font-weight: var(--font-weight);
  justify-content: center;
  margin-top: var(--spacing-scale-2x);
  position: absolute;
  top: 100%;
}
